// extracted by mini-css-extract-plugin
export default {"bounce":"N_dn","loading":"N_dp","logo-mark-bounce-right":"N_dq","logo-mark-bounce-left":"N_dr"};